import {NgModule} from '@angular/core';
import {PartnerSearchWithCreateAbilityComponent} from './partner-search-with-create-ability.component';
import {PartnerSearchModule} from '../partner-search/partner-search.module';
import {PartnerSaveDialogModule} from '../partner-save-dialog/partner-save-dialog.module';

@NgModule({
    declarations: [
        PartnerSearchWithCreateAbilityComponent,
    ],
    exports: [
        PartnerSearchWithCreateAbilityComponent
    ],
    imports: [
        PartnerSearchModule,
    ]
})
export class PartnerSearchWithCreateAbilityModule {}
